import React from 'react'
import { Modal } from 'react-bootstrap'

// Read-only Safety Systems view for the Client Portal. Safety system items are
// not editable here (that happens in the Admin Portal) — this simply shows
// which sensors are Equipped vs Optional based on the report's services.
const SafetySystemsModal = ({ show, onHide, report }) => {
  const services = (report.adas && report.adas.services) || []

  const seen = new Set()
  const equipped = []
  const optional = []
  services.forEach(svc => {
    const name = svc.sensorName || 'General'
    if (seen.has(name)) return
    seen.add(name)
    const isEquipped =
      svc.sensorAnswer === 'equipped' || svc.recommendedStatus === 'required'
    if (isEquipped) equipped.push(name)
    else optional.push(name)
  })

  const Column = ({ title, items, equipped }) => (
    <div className='adas-safety-column'>
      <h6 className='adas-safety-column-title'>{title}</h6>
      {items.length ? (
        items.map(name => (
          <div key={name} className='adas-safety-row-readonly'>
            <span>{name}</span>
            {equipped ? (
              <span className='adas-safety-equipped-badge'>Equipped</span>
            ) : (
              <span className='adas-safety-select-badge'>Select</span>
            )}
          </div>
        ))
      ) : (
        <p className='adas-safety-empty'>None</p>
      )}
    </div>
  )

  return (
    <Modal show={show} onHide={onHide} centered size='lg' dialogClassName='adas-safety-modal'>
      <button className='adas-modal-close' onClick={onHide} aria-label='Close'>&times;</button>
      <Modal.Body>
        <h3 className='adas-modal-title'>Safety Systems</h3>
        <p className='adas-modal-copy'>Identify the safety systems that are equipped on this vehicle.</p>
        <div className='adas-safety-grid'>
          <Column title='Equipped' items={equipped} equipped />
          <Column title='Optional' items={optional} />
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default SafetySystemsModal
